import { get, writable } from 'svelte/store';
import { refreshUserSession } from '../../app.logic';
import { SettingsService } from '../../services/settings.service';
export const loading = writable(false);
export const record = writable(null);
let initialized = false;
export async function init() {
    // if (!initialized) {
    //   initialized = true;
    //   //record.set(null);
    // }
    await loadRegionSettings();
}
export async function loadRegionSettings() {
    loading.set(true);
    try {
        let _resp = await SettingsService.fetchSettings();
        record.set(_resp.payload);
    }
    finally {
        loading.set(false);
    }
}
export async function save() {
    let _record = get(record);
    if (_record == null)
        return;
    await SettingsService.saveSettings(_record);
    await loadRegionSettings();
    // reload user session to update header
    //await refreshUserSession();
}
